import { render, staticRenderFns } from "./PaxGraphique.vue?vue&type=template&id=1e2f1a74&"
import script from "./PaxGraphique.vue?vue&type=script&lang=js&"
export * from "./PaxGraphique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports